<script lang="ts">
  let {
    size = 'md',
    label,
    class: className = ''
  }: {
    size?: 'sm' | 'md' | 'lg';
    label?: string;
    class?: string;
  } = $props();

  const a11y = $derived(
    label
      ? { role: 'status' as const, 'aria-label': label }
      : { 'aria-hidden': 'true' as const }
  );
</script>

<span class="spinner {className}" data-size={size} {...a11y}></span>

<style>
  .spinner {
    display: inline-block;
    border: 2px solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spinner-rotate 700ms linear infinite;
  }

  .spinner[data-size='sm'] { width: 14px; height: 14px; }
  .spinner[data-size='md'] { width: 18px; height: 18px; }
  .spinner[data-size='lg'] { width: 24px; height: 24px; }

  @keyframes spinner-rotate {
    to { transform: rotate(360deg); }
  }
</style>